<template>
  <div class="customer-confirmation">
    <bCardHeader :param="param" class="card-header"></bCardHeader>
    <el-row class="m0">
      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
        <div class="customer-confirmation-content card-base">
          <div v-for="(item, index) in checkDatasAgree" :key="index" class="check-item">
            <el-checkbox v-model="item.checked" test_id="check_box_want_to_buy"></el-checkbox>
            <div class="checked-text">
              <span class="checked-value">{{ item.data }}</span><a :href="item.link" v-if="item.link">{{
                item.linkContext }}</a> <span class="checked-value">{{ item.secondText }}</span>
            </div>
          </div>
          <div class="footer-btn-group">
            <el-button type="default" class="el-button-back" @click="back">
              {{ $t('common.back') }}
            </el-button>
            <el-button type="primary" :disabled="!hasCheckAgree" class="el-button-sub" @click="nextStep">
              {{ $t('common.sureBtn') }}
            </el-button>
          </div>
        </div>
      </el-col>
    </el-row>
        <bDialog :dialogVisible.sync="IsCodeShow" @closeChange="closeChange" :params="orderId" :closeModal="false"
      :component="componentDialog" :contiune="true" :showClose="false"></bDialog>
  </div>
</template>
<script>
import tradeApi from '@/api/v2/trade'
import complete from '../fund-transfer/info-dialog.vue'
import { mapGetters } from 'vuex'
import _ from 'lodash'
export default {
  data() {
    return {
      IsCodeShow: false, // 是否打开申请码弹窗
      componentDialog: complete, // 申请码弹窗内容
      orderId: {},
      stockObj: {},
      tradeAccountList: [],
      param: {
        title: 'trade_product',
        links: [
          {
            title: 'home'
          },
          {
            title: 'my_account'
          },
          {
            title: 'trade_product'
          }
        ]
      },
      checkDatasAgree: [
        {
          data: this.$t('tradeProduct.customerConfirmationOne'),
          checked: true,
          link: '',
          linkContext: '',
          secondText: '',
          type: 'isDeriveConfirmComplete'
        },
        {
          data: this.$t('tradeProduct.customerConfirmationTwo'),
          checked: true,
          link: '',
          linkContext: '',
          secondText: '',
          type: 'isDeriveConfirmMe'
        },
        {
          data: this.$t('tradeProduct.customerConfirmationThree'),
          checked: true,
          link: this.$t('tradeProduct.explanatoryNoteLink'),
          linkContext: this.$t('tradeProduct.explanatoryNote'),
          secondText: this.$t('tradeProduct.customerConfirmationThreeLast'),
          type: 'isDeriveConfirmRisk'
        },
        {
          data: this.$t('tradeProduct.customerConfirmationFour'),
          checked: true,
          link: '',
          linkContext: '',
          secondText: '',
          type: 'isDeriveConfirmUnderstand'
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['getAccountInfo']),
    hasCheckAgree() {
      return this.checkDatasAgree.every(item => {
        return item.checked
      })
    }
  },
  mounted() {
    this.getStockList()
  },
  methods: {
    getStockList() {
    this.tradeAccountList = this.getAccountInfo
    this.stockObj = _.find(this.tradeAccountList, {
        type: 'STOCK'
      })
    },
    closeChange() {
      this.openMessage('success', this.$t('tradeProduct.success'))
      this.$router.push('/trade-product')
    },
    async nextStep() {
      // 检查是否都同意的条款
      if (!this.hasCheckAgree) {
        return this.$message.error(this.$t('tradeProduct.agree'))
      }
      let tradeAccountList = [
        {
          number: this.stockObj.tradeAccountNumber,
          type: this.stockObj.tradeAccountType
        }
      ]
      let params = {
        isDeriveConfirmComplete: true,
        isDeriveConfirmMe: true,
        isDeriveConfirmRisk: true,
        isDeriveConfirmUnderstand: true,
        tradeAccountList: tradeAccountList,
        submitSource: 'CP_WEB'
      }
      tradeApi
        .commitStructuredProduct(params)
        .then(res => {
          if (res.code === 200) {
            this.orderId = { orderId: res.data.orderId }
            this.IsCodeShow = true // 提交之后返回
          }
        })
        .catch(error => {
          let err = JSON.parse(error.error)
          let msg = this.$t('tradeProduct.errorMsg.' + err.code)
          this.openMessage('error', msg)
        })
    },
    back() {
      this.$router.back()
    }
  }
}
</script>
<style lang="scss" scoped>
.customer-confirmation {
  .customer-confirmation-content {
    padding: 24px;

    .check-item {
      margin-bottom: 24px;
      display: flex;

      .checked-text {
        margin-left: 12px;
      }
    }

    .footer-btn-group {
      display: flex;
      align-items: center;
      gap: 12px;

      .el-button-back {
        flex: 1;
        max-width: 250px;
      }

      .el-button-sub {
        flex: 1;
        max-width: 250px;
      }
    }
  }
}
</style>
